import React, { useEffect } from "react";
import "./Education.css";
import { FaUserGraduate } from "react-icons/fa";
import Title from "../Title/Title";
import AOS from "aos";
import "aos/dist/aos.css";

const Education = () => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
    AOS.refresh();
  }, []);
  return (
    <>
      <div className="education-logo">
        <Title title="Educational Qualification" />
        <FaUserGraduate className="degree-icon" />
      </div>
      <section className="edu-content">
        <div className="degrees-box" data-aos="fade-right">
          <div className="flex-1">
            <p className="degree-title">Master Degree (2018-2021)</p>
          </div>
          <div className="flex-4">
            <p className="degree-details">
              Graduated Masters in Computer Science with overall GPA 7.2 at RIGA
              TECHNICAL UNIVERSITY, Riga,Latvia
            </p>
          </div>
        </div>

        <div className="degrees-box" data-aos="fade-left">
          <div className="flex-1">
            <p className="degree-title">Bachelors Degree (2012-2016)</p>
          </div>
          <div className="flex-4">
            <p className="degree-details">
              Graduated Bachelors in Computer Science with overall GPA 7.8 at
              SRM UNIVERSITY, Chennai , India
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Education;
